<template>
  <span>
    <div class="main-box" :id="`club-${club.id}`">
      <div class="photo club" :style="{'background': `url(${club.photo_orig}) no-repeat center / cover`}"></div>
      <div class="main-box-footer">
        <div class="inner">
            <div class="info club">
              <div class="name">
                {{ club.title }}
              </div>
              <div class="handle">
                @{{ club.handle }}
              </div>
          </div>
          <div class="details club">
            <div class="description snipped" v-if="club.description">
              <input type="checkbox" id="expanded">
              <p>{{ club.description }}</p>
              <label for="expanded" role="button"></label>
            </div>
            <div class="row first">
              <div class="detail group">{{ club.members_count }}</div>

              <div class="detail location notranslate">{{ club.address_type == 'city_only' || club.type == 'fun' || club.type == 'club' ?  (club.country_code && club.country_code.toLowerCase() === 'us' ? club.locality + ', ' +club.state : club.locality) : club.address }}</div>
            </div>
            
            <div class="row second" v-if="club.website">
              <div class="website">
                <a :href="getClubWebsite" target="_blank">{{ club.website }}</a>
              </div>
            </div>
          </div>
        </div>


        <div  class="favorites" v-if="members && membersCount">
          <div class="faces" >
            <div class="face"
                  v-for="user in members"
                  v-if="user.membershipStatus === 'requested' || (!club.hide_admin && user.id == club.user_id)"
                @click="openUser(user)"
                :class="{
                  'host': (user.membershipStatus === 'host'),
                  'online': user.isOnline,
                  'meet_now': user.meet_now,
                  'was-online': user.wasRecentlyOnline && !user.isOnline,
                  'pending': user.membershipStatus === 'requested'
            }">
              <div class="img"
                  :class="{'is-deleted': !!user.deleted_at}"
                  :style="!user.deleted_at && {'background': `url(${user.photo_small}) no-repeat center / cover`}">
              </div>
              <div class="membership-request" v-if="user.membershipStatus === 'requested'"
              @click.stop="updateUserMembership(user, 'accept', club)">
              </div>
              <div class="close"
                    v-if="club.membershipStatus === 'host' && user.id !== club.user_id && user.membershipStatus === 'member'"
              @click.stop="updateUserMembership(user, 'remove')">
              </div>
              <div class="details">
                  <div class="name notranslate">{{ user.headline }}</div>
              </div>
            </div>


            <div class="face"
                  v-for="user in invitedUsers"
                  v-if="user.membershipStatus === 'invited' && user.id != club.user_id"
                @click="openUser(user)"
                :class="{
                  'host': (user.status === 'host'),
                  'meet_now': user.meet_now,
                  'online': user.isOnline,
                  'was-online': user.wasRecentlyOnline && !user.isOnline,
                  'pending-wait': user.membershipStatus === 'invited'
            }">
              <div class="img"
                  :class="{'is-deleted': !!user.deleted_at}"
                  :style="!user.deleted_at && {'background': `url(${user.photo_small}) no-repeat center / cover`}">
              </div>
                            <div class="close"
                                 v-if="club.membership === 'host' && user.id !== club.user_id"
                                 @click.stop="deleteInvitation({ eventId: club.id, user_id:user.id})">
                            </div>
              <div class="details">
                  <div class="name notranslate">{{ user.headline }}</div>
              </div>
            </div>

            <div class="add-private-member face" @click="openPrivateInvite()" v-if="club.is_private && (club.membershipStatus === 'host' || club.membership === 'host')">
              <img src="/main/img/icons/add.svg">
            </div>
            <div class="face"
                  v-for="user in members"
                  v-if="user.membershipStatus !== 'requested' && user.membershipStatus !== 'host'"
                @click="openUser(user)"
                :class="{
                  'host': (user.membershipStatus === 'host'),
                  'online': user.isOnline,
                  'meet_now': user.meet_now,
                  'was-online': user.wasRecentlyOnline && !user.isOnline,
                  'pending': user.membershipStatus === 'requested'
            }">
              <div class="img"
                  :class="{'is-deleted': !!user.deleted_at}"
                  :style="!user.deleted_at && {'background': `url(${user.photo_small}) no-repeat center / cover`}">
              </div>
              <div class="membership-request"
                    v-if="user.membershipStatus === 'requested'"
              @click.stop="updateUserMembership(user, 'accept', club)">
              </div>
              <div class="close"
                    v-if="club.membershipStatus === 'host' && user.id !== club.user_id && user.membershipStatus === 'member'"
              @click.stop="updateUserMembership(user, 'remove')">
              </div>
              <div class="details">
                  <div class="name notranslate">{{ user.headline }}</div>
              </div>
            </div>

          </div>
        </div>
       <infinite-loading
           :force-use-infinite-wrapper="isMobile ? '.page-bang' : '#event-details'"
           ref="infiniteLoadingClubMembers"
           direction="bottom"
           @infinite="loadClubMembers"
           spinner="bubbles">
              <span slot="no-more"></span>
              <span slot="no-results"></span>
            </infinite-loading>

        <transition name="slide-in-fwd-center">
          <div id="club-location-map" class="club-location-map"
              v-if="locationPreviewVisible"
              v-on:hide-alert="locationPreviewVisible = false">
              <Map :lat="club.lat"
                   :lng="club.lng"
                  :zoom="15"
                 styles="height: 260px; width: 100%;"
             :clickable="true"
             :draggable="false" />
          </div>
        </transition>

      </div>
        <transition name="fade">
          <div v-show="showScrollTop" class="scroll_top-button"
               @click="scrollToTop()" :title="trans('arrow_scroll_top')">
            <svg class="icon icon-arrow_up">
              <use v-bind:xlink:href="symbolsSvgUrl('icon-arrow_up')"></use>
            </svg>
          </div>
        </transition>
        <div class="func-buttons club" style="{'justify-content': 'flex-start'}">
          <div class="send-message"
               v-if="['host', 'member'].includes(club.membershipStatus)"
               v-on:click="startGroupConversation(club.id, true, club.conversation_id)"
               :class="{'notificated': club.unreadMessagesCount}">
          </div>

          <div v-if="club.is_private && club.membershipStatus != undefined" class="is-private-block">
            <svg width="20" height="27" viewBox="0 0 20 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 9H16.25V6.5C16.25 3.05 13.45 0.25 10 0.25C6.55 0.25 3.75 3.05 3.75 6.5V9H2.5C1.125 9 0 10.125 0 11.5V24C0 25.375 1.125 26.5 2.5 26.5H17.5C18.875 26.5 20 25.375 20 24V11.5C20 10.125 18.875 9 17.5 9ZM10 20.25C8.625 20.25 7.5 19.125 7.5 17.75C7.5 16.375 8.625 15.25 10 15.25C11.375 15.25 12.5 16.375 12.5 17.75C12.5 19.125 11.375 20.25 10 20.25ZM6.25 9V6.5C6.25 4.425 7.925 2.75 10 2.75C12.075 2.75 13.75 4.425 13.75 6.5V9H6.25Z" fill="#9D9D9D"/>
            </svg>
          </div>

          <strong v-if="club.membershipStatus == 'invited'" class="invited-text">You have been invited!</strong>

          <div :class="{buttons:true, notranslate:true, twoButtons:(club.membershipStatus == 'invited' && club.is_private)}">
            <button type="button"
                    class="btn"
                    v-if="!isMyClub(club) && (club.membershipStatus != 'invited')"
                    @click="updateMembership({ clubId: clubIdComputed })"
                    :disabled="membershipActionDisabled"
            >{{ membershipActionText }}</button>

            <button type="button"
                    class="btn darker"
                    v-if="club.membershipStatus == 'invited'"
                    @click="declineInvite({ eventId: clubIdComputed })"
                    :disabled="membershipActionDisabled"
            >{{ trans('clubs.decline') }}</button>

            <button type="button"
                    class="btn"
                    v-if="club.membershipStatus == 'invited'"
                    @click="acceptInvite({ eventId: clubIdComputed })"
                    :disabled="membershipActionDisabled"
            >{{ trans('clubs.accept') }}</button>

            <button type="button"
                    v-if="isMyClub(club)"
                    @click="editClub(club.id, 'club')"
                    class="edit-button btn">
                {{ trans('edit') }}
            </button>
          </div>
        </div>
    </div>

    <vue-custom-scrollbar :class="{'opened': inviteBlockOpened, 'favourites-list': true}">
      <div class="invite-menu">
        <div class="title">Invite favourite buddies</div>
        <div class="close" @click="closeInviteBlock"></div>
        <div class="wrapper">
          <div class="inner">
            <div class="sharing-block">
              <div class="faces">
                  <div class="face"
                      v-for="(user, index) in favorites"
                      v-if="user.membershipStatus !== 'requested' && user.id != club.user_id"
                      @click="selectUser(user.id, index, user.active)"
                      :class="{'selected': user.active}">
                      <div class="img" 
                          :class="{'is-deleted': !!user.deleted_at}"
                          :style="!user.deleted_at && {'background': `url(${user.photo_small}) no-repeat center / cover`}">
                      </div>
                      <div class="details">
                          <div class="name notranslate">{{ user.headline }}</div>
                      </div>
                  </div>
              </div>
              <infinite-loading
                  ref="infiniteLoadingFavorites"
                  v-if="inviteBlockOpened"
                  @infinite="getFavorites"
                  spinner="bubbles"
                  direction="bottom">
                <span slot="no-results" v-if="false">Favorites not exists</span>
                <span slot="no-more" v-if="false">No more favorites</span>
              </infinite-loading>
            </div>
          </div>
        </div>
      </div>
    </vue-custom-scrollbar>

    <div class="inviteButtons" v-if="selectedMembers.length > 0 && inviteBlockOpened" @click="handleInvites()">
      <button class="inviteButton btn" type="button">
        {{ trans('clubs.invite') }}
      </button>
    </div>

  </span>
</template>

<script>
    import clubsModule from '@clubs/module/store/type';
    import Map from '@buddy/views/widgets/Map.vue';
    import Alert from '@buddy/views/widgets/Alert.vue';
    import EditClub from '@clubs/views/desktop/club/Edit.vue';
    import auth from '@general/lib/auth';

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import {mapActions, mapGetters, mapState} from "vuex";
    import axios from "axios";

    export default {
        mixins: [
	        require('@general/lib/mixin').default,
          require('@general/lib/mixin-clubs').default,
	        require('@general/lib/mixin-chat').default,
		],
        props: ['clubId'],
        components: {
            Alert,
            Map,
            EditClub,
            vueCustomScrollbar
        },
        data: () => ({
            locationPreviewVisible: false,
            inviteBlockOpened: false,
            selectedMembers:[],
            showScrollTop: false,
        }),
        computed: {
            ...mapState({
                blockedUsersIds: state => state.blockedUsersIds,
            }),
            ...mapGetters({
              favorites : "favorites",
              favoritesPage: "getFavoritesPage"
            }),
            getClubWebsite() {
                return this.club.website.startsWith('https://') || this.club.website.startsWith('http://') ? this.club.website : `//${this.club.website}`
            },
            clubIdComputed(){
                let clubId = this.clubId
                console.log('[club Item] clubIdComputed', { clubId })
                return clubId
            },
            club(){
              return this.$store.getters.getClub(this.clubIdComputed)
            },
            members() {
              if(this.club.members){
                return this.club.members;
              }else{
                return [];
              }
            },
            membersCount() {
                return this.members.length
            },
            invitedUsers() {
              if(this.club.invitedMembers){
                return this.club.invitedMembers.filter(member => this.club.membershipStatus !== 'host' || !this.blockedUsersIds.includes(member.id))
              }else{
                return [];
              }
            },
            invitedUsersCount() {
                return this.invitedUsers.length
            },
        },
      created() {
        app.$on('open-club', this.openClub)
        console.log('[Club Widget Item] Created')
        if(this.isDesktop){
          this.resetMembers();
        }
      },
      methods: {
            ...mapActions({
              inviteBuddies:    'inviteBuddies',
              toggleClubLike:    clubsModule.actions.clubs.like,
              requestMembership: clubsModule.actions.membership.request,
              signalClubSeen : 'signalClubSeen',
              getFavorites: "getFavorites"
            }),

            deleteInvitation(data){
              this.deleteEventInvitation(data);
              this.$store.dispatch(clubsModule.actions.clubs.updateInvitedMembers,
                  {
                    club_id: this.club.id,
                    members: this.invitedUsers.filter(member => member.id !== data.user_id)
                  }
              )
            },
            checkScrollDebounce: _.debounce(function (event) {
              if (event) {
                let currentScroll = event.target.scrollTop;
                this.showScrollTop = currentScroll >= 370;
              }
            }, 100),
            scrollToTop() {
              var container;
              if(this.isMobile){
                let y = document.getElementsByClassName('page-bang');
                container = y[0];
              }else{
                container = document.getElementById('event-details');
              }
              container.scrollTo({
                top: 0,
              })
            },
            resetMembers(){
              this.$store.dispatch(clubsModule.actions.clubs.updateMembers,{club_id:this.club.id,members: []})
              this.$store.dispatch(clubsModule.actions.clubs.updateInvitedMembers,{club_id:this.club.id,members: []})
              this.$store.commit(clubsModule.mutations.clubs.setPageMembersNum, 0);
            },
            async loadClubMembers(infiniteScroll) {
              let self = this;
              //fixing issue with loading info of club after loading members
              let datesCount = await self.$store.dispatch(clubsModule.actions.clubs.loadMembers, self.club)
              infiniteScroll.loaded()
              if (datesCount) {
                infiniteScroll.complete()
              }

            },
            declineInvite(data) {
              let self= this;
              let callback = function (){
                self.showSuccessNotification('Invitation successfully declined')
                self.$store.dispatch('loadCurrentUserInfo');
                self.goTo('/clubs');
                  setTimeout(function(){
                    app.$emit('reload-clubs')
                    if(self.club.is_private){
                      self.closeClub();
                    }else{
                      app.$emit('open-club', data.eventId + '?', 'club')
                    }
                  }, 750)
              }
              this.declineClubInvitation(data, callback);
            },
            acceptInvite(data) {
              let self = this;
              let callback = function(){
                self.showSuccessNotification('Invitation successfully accepted')
                self.$store.dispatch('loadCurrentUserInfo');
                setTimeout(function(){
                  app.$emit('reload-clubs')
                  app.$emit('open-club', data.eventId + '?', 'club')
                }, 750)
              }
              this.acceptClubInvitation(data, callback);
            },
            async handleInvites() {
              await this.inviteBuddies({
                selectedMembers: this.selectedMembers,
                eventIdComputed: this.clubIdComputed,
              });
              this.closeInviteBlock();
              this.resetMembers();
              if (this.$refs.infiniteLoadingClubMembers) {
                this.$refs.infiniteLoadingClubMembers.stateChanger.reset();
              }
              this.selectedMembers = [];
              this.favorites.map(function (user) {
                user.active = false;
              })
              this.showSuccessNotification('Users successfully invited');
            },

            selectUser(userId, index, userActive) {
              if (!userId) {
                return;
              }

              let currentMember = this.favorites[index]
              let allMembers = this.favorites

              currentMember.active = !currentMember.active

              if (currentMember.active) {
                this.selectedMembers.push(userId)
              } else {
                this.selectedMembers.splice(_.findIndex(this.selectedMembers, userId), 1)
              }

              this.$set(allMembers, index, currentMember)
            },
            openPrivateInvite() {
              this.inviteBlockOpened = true;

              this.$nextTick(() => {
                if (this.$refs.infiniteLoadingFavorites && this.favoritesPage === 1) {
                  this.$refs.infiniteLoadingFavorites.stateChanger.reset();
                }
              });
            },
            closeInviteBlock() {
              this.inviteBlockOpened = false;
            },
            async openUser(user){
                let validUser = await this.$store.dispatch('loadUserInfo', user.id)
                if (!validUser){
                  return false
                }
                if(validUser.error){
                  this.showNotification({message: validUser.error}, 'error')
                  return false
                }

                if (user.deleted_at) {
                    this.showErrorNotification('profile_is_deleted')
                } else {
                    let userToken = user.handle || user.id
                    if (this.isMobile) {
                        this.goTo('/user/' + userToken)
                        // this.openUserMobileModal(userToken);
                    } else {
                        this.openUserModal(userToken)
                    }
                }
            },
            openMap() {
              this.locationPreviewVisible = !this.locationPreviewVisible

              if (this.locationPreviewVisible) {
                  this.$nextTick(() => {
                    if (this.isMobile) {
                      document.getElementById('club-location-map').scrollIntoView();
                    } else {
                      const scrollDiv = document.getElementById('club-details');
                      const mapBox = document.getElementById('club-location-map');
                      const coordinates = scrollDiv.scrollHeight - mapBox.offsetHeight;

                      scrollDiv.scroll({
                        top: coordinates,
                      });
                    }
                  });
              }
            },
        },
        beforeMount() {
        },
      activated(){
        console.log('[Club Widget Item] Activated')
        if(this.isMobile){
          this.resetMembers();
          this.$refs.infiniteLoadingClubMembers.stateChanger.reset();
        }
      },
      mounted() {
          var container;
          if(this.isMobile){
            let y = document.getElementsByClassName('page-bang');
            container = y[0];
          }else{
            container = document.getElementById('event-details');
          }
          if (container) {
            container.addEventListener('scroll', this.checkScrollDebounce, true);
          }
          const ps = document.querySelectorAll('.club .description p');
          const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
              entry.target.classList[entry.target.scrollHeight > entry.contentRect.height ? 'add' : 'remove']('truncated');
            }
          });

          ps.forEach(p => {
            observer.observe(p);
          });

          console.log('[Club Widget Item] Mounted', {
              clubId: this.clubIdComputed,
              club: this.club
          })

          if (!!parseInt(this.clubIdComputed) && auth.getUserId() === this.club.user_id){
              this.signalClubSeen(this.club);
              //this.$store.dispatch(clubsModule.actions.membership.remove, this.clubIdComputed)
          }


          if(auth.isAuthenticated() && auth.getUserId() === this.club.user_id){
            this.$store.commit('setFavorites',[]);
            this.$store.commit('setFavoritesPage', 1);
          }
        },
    }
</script>
